import { useValidations } from "@sttedra_ui/framework";
import { searchValue } from "@/composables/_commons/helper.js";

const { required } = useValidations();

export default function (object = null) {
  return {
    items: [
      {
        field: "nombre",
        label: "Nombre",
        value: searchValue(object, "nombre"),
        rules: { required },
        classObj: ["col-12"],
      },
    ],
  };
}
